import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';

import { ICustomer } from '../../models';
import { Constants } from '@config/constants';
import { ErrorHandlingService } from '../error-handling/error.handling.service';

@Injectable()
export class CustomerService {
  constructor(
    private readonly http: HttpClient,
    private readonly constants: Constants,
    private readonly errorHandlingService: ErrorHandlingService
  ) { }

  findAllCustomers = (): Observable<ICustomer[]> =>
    this.http
      .get<ICustomer[]>(this.constants.CUSTOMER_ENDPOINT)
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

  findOneCustomer = (id: number): Observable<ICustomer> =>
    this.http
      .get<ICustomer>(this.constants.CUSTOMER_ENDPOINT + `/${id}`)
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

  addCustomer = (customer: Partial<ICustomer>): Observable<ICustomer> =>
    this.http
      .post<ICustomer>(this.constants.CUSTOMER_ENDPOINT, customer)
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

  updateCustomer = (
    id: number,
    paramsToUpdate: Partial<ICustomer>
  ): Observable<ICustomer> =>
    this.http
      .patch<ICustomer>(
        this.constants.CUSTOMER_ENDPOINT + `/${id}`,
        paramsToUpdate
      )
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

  deleteCustomer = (
    id: number
  ): Observable<void> =>
    this.http
      .delete<void>(
        `${this.constants.CUSTOMER_ENDPOINT}/${id}`
      )
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

}
